import React from 'react';
import PropTypes from 'prop-types';
import '../css/hero-display.css';

const HeroDisplay = props => (
  <div id="hero__container">
    <div id="hero__content">
      <img src="images/hero-logo.jpg" alt="Patriots General Manager logo" />
      <h1 className="miller-bold">How would you rebuild the Patriots?</h1>
      <h2 className="miller-bold">With ample cap space and the No. 15 draft pick, which players would you add while staying below the salary cap?</h2>
      <div className="byline-block">
        <p className="benton-regular">By <a target="_blank" rel="noreferrer" href="https://www.bostonglobe.com/about/staff-list/staff/ben-volin/">Ben Volin</a> | Globe Staff</p>
        <p className="benton-regular">Published {props.pubDate} </p>
        {props.updateDate.length > 0 ? <p className="benton-regular">Updated {props.updateDate} </p> : null}
      </div>
    </div>
  </div>
)

HeroDisplay.propTypes = {
  pubDate: PropTypes.string,
  updateDate: PropTypes.string,
}


export default HeroDisplay;